import { NavLink } from 'react-router-dom';
import { useI18n } from '../i18n';

/*
 * Ícones desenhados à mão, em traço, herdando a cor do link.
 *
 * Emoji parecia rascunho: cada sistema desenha o seu, o peso visual muda entre
 * eles e não dá para animar as partes. Em SVG o traço acompanha o estado do
 * item e cada figura tem o mesmo peso de linha.
 */

function IconeCarrinho() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 4h2.2l2.2 10.4a1.6 1.6 0 0 0 1.6 1.3h8.3a1.6 1.6 0 0 0 1.6-1.2L21 7.5H6.2" />
      <circle cx="9.5" cy="19.5" r="1.4" />
      <circle cx="17.5" cy="19.5" r="1.4" />
    </svg>
  );
}

function IconeVenda() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      {/* Nota de dinheiro com a moeda ao centro. */}
      <rect x="2.5" y="6" width="19" height="12" rx="2" />
      <circle cx="12" cy="12" r="2.6" />
      <path d="M6 9.5v5M18 9.5v5" />
    </svg>
  );
}

function IconeUpgrade() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      {/* Duas setas em sentidos opostos: a troca. */}
      <path d="M4 8.5h13l-3-3" />
      <path d="M20 15.5H7l3 3" />
    </svg>
  );
}

/**
 * Os três caminhos do site.
 *
 * Encomendar é o catálogo (comprar de nós); as outras duas partem do inventário
 * do cliente — vender tudo por dinheiro, ou usar como pagamento numa troca.
 */
export function MainNav() {
  const { lang } = useI18n();
  const pt = lang === 'pt';

  const itens = [
    { to: '/all', Icone: IconeCarrinho, label: pt ? 'Skins disponíveis' : 'Available skins' },
    { to: '/vender', Icone: IconeVenda, label: pt ? 'Venda de inventário' : 'Sell inventory' },
    // "Trocar skins" diz o que acontece ali; "Upgrade" era o nome interno da
    // operação e deixava o cliente adivinhando.
    { to: '/upgrade', Icone: IconeUpgrade, label: pt ? 'Trocar skins' : 'Trade skins' },
  ];

  return (
    <nav className="main-nav" aria-label={pt ? 'Menu principal' : 'Main menu'}>
      <div className="main-nav-inner">
        {itens.map(({ to, Icone, label }) => (
          <NavLink key={to} to={to} className={({ isActive }) => `main-nav-item ${isActive ? 'active' : ''}`}>
            <span className="mn-icon" aria-hidden>
              <Icone />
            </span>
            <span className="mn-label">{label}</span>
            {/* O traço de baixo cresce a partir do centro ao ficar ativo. */}
            <span className="mn-underline" aria-hidden />
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
